import { render } from "./chiller.vue?vue&type=template&id=9022b678&scoped=true"
const script = {}

import "./chiller.vue?vue&type=style&index=0&id=9022b678&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9022b678"

export default script